import i18n from "../../../i18n";
import LocalizationMode from "./localization-mode";

export enum SpatialPropertyType {
  Static = "Static",
  HighBayStorage = "HighBayStorage",
  BlockStorage = "BlockStorage",
  Dynamic = "Dynamic",
}

export const DEFAULT_SPATIAL_PROPERTY_TYPE = SpatialPropertyType.HighBayStorage;

export const getSpatialPropertySliderValues = (isBlockStorageEnabled?: boolean) =>
  [
    { value: 0, type: SpatialPropertyType.Static, label: i18n.t(SpatialPropertyType.Static) },
    { value: 1, type: SpatialPropertyType.HighBayStorage, label: "" },
    { value: 2, type: SpatialPropertyType.BlockStorage, label: "" },
    { value: 3, type: SpatialPropertyType.Dynamic, label: i18n.t(`${SpatialPropertyType.Dynamic}.label`) },
  ]
    .filter((v) => v.type !== SpatialPropertyType.BlockStorage || isBlockStorageEnabled === true)
    .map((item, index) => ({ ...item, value: index }));

export default interface ISpatialProperty {
  type: SpatialPropertyType;
  localizationMode: LocalizationMode;
  useSlamLite: boolean;
  zoneExplorationEnabled: boolean;
}
